export default __webpack_public_path__ + "portfolio07.jpg";